import { useCssVars as _useCssVars, unref as _unref, defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toHandlers as _toHandlers, mergeProps as _mergeProps, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-66cc8847"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["label", "disabled", "checked"]
const _hoisted_2 = { key: 1 }

import { computed, withDefaults, useAttrs } from 'vue';
import omit from '@/utils/omit';

// const { calcFieldSize } = useField()


const __default__ = {
  inheritAttrs: false,
};

interface InputProps {
  modelValue?: any;
  label?: string;
  disabled?: boolean;
  checked?: boolean;
  labelStart?: boolean;
  labelEnd?: boolean;
  noMargin?: boolean;
  sizeLabel?: string
  colorLabel?: string
}


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  __name: 'AtomCheckBox',
  props: {
    modelValue: { default: '' },
    label: {},
    disabled: { type: Boolean },
    checked: { type: Boolean },
    labelStart: { type: Boolean, default: false },
    labelEnd: { type: Boolean, default: true },
    noMargin: { type: Boolean },
    sizeLabel: {},
    colorLabel: { default: '#212529' }
  },
  emits: ["update:modelValue", "click", "keydown", "focus", "update:hint"],
  setup(__props: any, { emit: __emit }) {

_useCssVars(_ctx => ({
  "670130aa": (_ctx.colorLabel)
}))

const props = __props;

const emit = __emit;
// const emit = defineEmits(['click', 'keydown', 'update:modelValue', 'focus', 'update:hint'])

const attrs = useAttrs();

const listeners = computed(() => ({
  input: emitValue,
  keydown: processValue,
  blur: (e: Event) => {
    if (typeof attrs.onBlur === 'function') attrs.onBlur(e);
  },
  focus: (e: PointerEvent) => emit('focus', e),
}));

const attributes = computed(() => omit(attrs, 'class'));

const processValue = (event: KeyboardEvent) => {
  if (!event.key) return;

  emit('keydown', event);
};

const emitValue = (event: InputEvent) => {
  const value = (event.target as HTMLInputElement).checked;
  emit('update:modelValue', value);
};
// const value = computed({
//   get: () => props.modelValue,
//   set: (value: any) => emit('update:modelValue', value),
// })


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("label", {
    class: "label-check py-1",
    style: _normalizeStyle({ fontSize: props.sizeLabel === 'lg' ? '18px' : '' })
  }, [
    (props.label && props.labelStart)
      ? (_openBlock(), _createElementBlock("span", {
          key: 0,
          class: _normalizeClass(`ms-3 me-auto`),
          style: _normalizeStyle({ fontSize: props.sizeLabel === 'lg' ? '18px' : '' })
        }, _toDisplayString(props.label), 5))
      : _createCommentVNode("", true),
    _createElementVNode("input", _mergeProps({
      type: "checkbox",
      class: `${_ctx.noMargin ? '' : 'ms-8'} justify-end`
    }, attributes.value, {
      label: props.label,
      disabled: _ctx.disabled,
      checked: _ctx.checked
    }, _toHandlers(listeners.value, true)), null, 16, _hoisted_1),
    (props.label && props.labelEnd)
      ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(props.label), 1))
      : _createCommentVNode("", true)
  ], 4))
}
}

})